import "babel-polyfill";
import React, { Fragment, useState } from "react";
import {
  Navbar,
  Nav,
  NavItem,
  MenuItem,
  NavDropdown,
  Modal,
  Button
} from "react-bootstrap";
import logo from "images/aicomposz-logo-HighRes-White-Trans.png";

import profile from "images/blankProfile.png";

function Mynavbar(user_id, user_name, has_view_products, imgCredits, mobile) {
  const [showPurchase, setShowPurchase] = useState(false);
  const [show3, setShow3] = useState(false);
  const showDropdown3 = (e) => {
    setShow3(true);
  };
  const hideDropdown3 = (e) => {
    setShow3(false);
  };

  const [show2, setShow2] = useState(false);
  const showDropdown2 = (e) => {
    setShow2(true);
  };
  const hideDropdown2 = (e) => {
    setShow2(false);
  };

  const [show1, setShow1] = useState(false);
  const showDropdown1 = (e) => {
    setShow1(true);
    setShow(false);
  };
  const hideDropdown1 = (e) => {
    setShow1(false);
  };

  const [show, setShow] = useState(false);
  const showDropdown = (e) => {
    setShow(true);
  };
  const hideDropdown = (e) => {
    setShow(false);
  };
  const toggleShow = (e) => {
    setShow(!show);
    setShow1(false);
    setShow2(false);
    setShow3(false);
  };
  const toggleShow1 = (e) => {
    setShow1(!show1);
    setShow(false);
    setShow2(false);
    setShow3(false);
  };
  const toggleShow2 = (e) => {
    setShow2(!show2);
    setShow(false);
    setShow1(false);
    setShow3(false);
  };
  const toggleShow3 = (e) => {
    setShow3(!show3);
    setShow(false);
    setShow1(false);
    setShow2(false);
  };

  const hideDD = (e) => {
    toggleShow();
    $("#responsive-navbar-nav").removeClass("navbar-collapse collapse in");
    $("#responsive-navbar-nav").addClass("navbar-collapse collapse");
    const el = document.getElementById("nav-toggle");
    el.click();
  };

  const hideDD1 = (e) => {
    toggleShow1();
    $("#responsive-navbar-nav").removeClass("navbar-collapse collapse in");
    $("#responsive-navbar-nav").addClass("navbar-collapse collapse");
    const el = document.getElementById("nav-toggle");
    el.click();
  };

  const handleToggle = (e) => {
    // do nothing
  };

  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  const countryCode = getCookie("countryCode");
  //    const countryCode = "US"

  const [showPricing, setShowPricing] = useState(false);
  const [showAbout, setShowAbout] = useState(false);

  return window.innerWidth > 450 ? (
    <React.Fragment>
      <Navbar
        expand="lg"
        inverse
        collapseOnSelect
        style={{
          border: "none",
          backgroundColor: "#29335b"
        }}
        className="fixed top-0 w-full z-50 glass px-6 py-1  flex justify-between items-center"
      >
        <Navbar.Brand>
          <a href="/" style={{ marginTop: "-18px" }}>
            <img height="60px" src={logo} />
          </a>
        </Navbar.Brand>
        {user_id != -1 ? (
          <Fragment>
            <Nav pullRight>
              {/* {user_id!=-1? */}

              <NavDropdown
                eventKey={2}
                id="4"
                title={
                  <img
                    height="20px"
                    src={profile}
                    style={{ marginTop: "-5px", paddingTop: "3px" }}
                  />
                }
                onMouseEnter={showDropdown3}
                onMouseLeave={hideDropdown3}
                open={show3}
                style={{ paddingTop: "3px" }}
                onToggle={handleToggle}
              >
                <div style={{ display: show3 ? "block" : "none" }}>
                  <li className="dropdown-header">
                    <span
                      style={{
                        marginLeft: "-15px",
                        textAlign: "center",
                        color: "gray",
                        fontWeight: "normal",
                        fontSize: "125%"
                      }}
                    >
                      Logged in as:{" "}
                    </span>
                    <br></br>
                    <span
                      style={{
                        marginLeft: "-15px",
                        textAlign: "center",
                        color: "black",
                        fontWeight: "bold",
                        fontSize: "125%"
                      }}
                    >
                      {user_name}
                    </span>
                  </li>
                  <MenuItem
                    eventKey={3.1}
                    href="/users/sign_out"
                    data-method="delete"
                    style={{ backgroundColor: "#ff0000" }}
                  >
                    <span
                      style={{
                        paddingLeft: "5px",
                        color: "white",
                        fontWeight: "normal",
                        fontSize: "125%"
                      }}
                    >
                      Log out
                    </span>
                  </MenuItem>
                </div>
              </NavDropdown>
            </Nav>
          </Fragment>
        ) : (
          <Navbar.Collapse>
            <Nav pullRight>
              <NavItem eventKey={3} href="/users/sign_in">
                Login
              </NavItem>
            </Nav>
          </Navbar.Collapse>
        )}
      </Navbar>
    </React.Fragment>
  ) : (
    // mobile below

    <React.Fragment>
      <Navbar
        collapseOnSelect
        className="fixed top-0 w-full z-50 glass px-16"
        style={{ border: "none", backgroundColor: "#29335b" }}
      >
        <div
          style={{
            paddingTop: "10px",
            marginBottom: "10px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%"
          }}
        >
          <a href="/" className="navbar-left">
            <img height="50px" src={logo} />
          </a>

          <Navbar.Toggle
            id="nav-toggle"
            style={{
              backgroundColor: "#fff",
              height: "25px",
              paddingTop: "6px",
              marginTop: "7px"
            }}
          />
        </div>

        <div
          style={{
            position: "absolute",
            right: "1px",
            zIndex: "1000",
            width: "40vw"
          }}
        >
          <Navbar.Collapse
            id="responsive-navbar-nav"
            style={{ backgroundColor: "#2c354f" }}
          >
            {user_id != -1 ? (
              <Nav pullRight>
                {/* {user_id!=-1? */}

                <NavDropdown
                  className="dropdown open"
                  eventKey={2}
                  id="4"
                  title={<img height="20px" src={profile} />}
                  onClick={toggleShow3}
                  open={show3}
                  onToggle={handleToggle}
                  onMouseEnter={toggleShow3}
                  onMouseLeave={toggleShow3}
                >
                  <div style={{ display: show3 ? "block" : "none" }}>
                    <li className="dropdown-header">
                      <span
                        style={{
                          marginLeft: "-20px",
                          textAlign: "center",
                          color: "yellow",
                          fontWeight: "normal",
                          fontSize: "125%"
                        }}
                      >
                        Logged in as:{" "}
                      </span>
                      <br></br>
                      <span
                        style={{
                          marginLeft: "-20px",
                          textAlign: "center",
                          color: "white",
                          fontWeight: "bold",
                          fontSize: "125%"
                        }}
                      >
                        {user_name}
                      </span>
                    </li>
                    <MenuItem
                      eventKey={3.1}
                      href="/users/sign_out"
                      data-method="delete"
                      style={{ backgroundColor: "#ff0000" }}
                    >
                      <span
                        style={{
                          paddingLeft: "5px",
                          color: "white",
                          fontWeight: "normal",
                          fontSize: "125%"
                        }}
                      >
                        Log out
                      </span>
                    </MenuItem>
                  </div>
                </NavDropdown>
              </Nav>
            ) : (
              <Nav>
                <NavItem
                  divider="true"
                  style={{ backgroundColor: "white", height: "1px" }}
                />
                <NavItem href="/users/sign_in">
                  <span style={{ color: "white", marginLeft: "5px" }}>
                    Login
                  </span>
                </NavItem>
              </Nav>
            )}
          </Navbar.Collapse>
        </div>
      </Navbar>
    </React.Fragment>
  );
}

export default Mynavbar;
